import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    device: 'pc',
    navList: [
      {
        name: '首页',
        key: 'index',
        path: '/index',
        activated: false
      },
      {
        name: '主营业务',
        key: 'business',
        path: '/business',
        activated: false
      },
      {
        name: '加入我们',
        key: 'join',
        path: '/join',
        activated: false
      },
      {
        name: '下载',
        key: 'download',
        path: '/download',
        activated: false
      }
    ],
    activated: sessionStorage.getItem('activated') || '/index',
    url: 'http://zk.bjjckx.com/',
    commonDownloadUrl: 'http://test.bjjckx.com/#/pages/guide-download/guide-download',
    downloadAppUrl: 'http://www.bjjckx.com/dl/caidao.apk'
  },

  mutations: {
    setDevice (state, data) {
      state.device = data
    },

    setActivated (state, data) {
      sessionStorage.setItem('activated', data)
      state.activated = data
    }
  },

  getters: {
    useNavList (state) {
      const useNavList = state.navList.map(item => {
        item.activated = false
        if (item.path === state.activated) {
          item.activated = true
        }
        return item
      })

      return useNavList
    }
  },

  modules: {
  }
})
